import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {Link} from 'react-router';

import {formatPosition} from 'modules/HorseRacing/utils';

import Silk from 'modules/Common/components/Silk';
import Ordinal from 'modules/Common/components/Ordinal';
import SubscriptionContainer from 'modules/Common/containers/Subscriptions/SubscriptionContainer';
import MyStableButton from 'modules/Common/containers/Subscriptions/MyStableButton';

require("./HorseRacingRacecardResultRunner.scss");

export default class HorseRacingRacecardResultRunner extends Component {

  static propTypes = {
    runner: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {expanded: false};
  }

  toggleExpanded() {
    this.setState({expanded: !this.state.expanded});
  }

  render(){
    const {
      runner,
      runner: {
        finishDistance,
        saddleClothNo,
        drawNumber,
        horseName,
        horseAge,
        weight,
        odds,
        trainer,
        jockey,
        jockeyClaim,
        rideDesc,
        betMovements,
        horseId,
        silkFilename
      }
    } = this.props;

    const finalPosition = formatPosition(runner, {defaultPosition: "N/A", showRunnerCount: false});
    const rideDescPlusBetMovements = [rideDesc, betMovements].join(' ').trim();

    return (
      <section id={`${this.props.runner.key}`} className="hr-racing-runner-wrapper">
        <div className="hr-racing-runner-position-container">
          <div className="hr-racing-runner-position">
            <div className="row">
              <span className="hr-racing-runner-position-no"><Ordinal n={finalPosition}/></span>
            </div>
          </div>
          <div className="hr-racing-runner-silks">
            <Silk filename={silkFilename}/>
          </div>
          <div className="hr-racing-runner-space-from-winner">
            {finishDistance}
          </div>
          <div className="hr-racing-runner-saddle-stall-info">
            <div className="row">
              <span className="hr-racing-runner-saddle-cloth-no">{saddleClothNo}</span>
            </div>
            <div className="row">
              <span className="hr-racing-runner-stall-no">{drawNumber}</span>
            </div>
          </div>

          <div className="hr-racing-runner-horse-info">
            <div className="row">
              <span className="hr-racing-runner-horse-name">
                <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link>
              </span>
            </div>
            <div className="row">
              <div className="hr-racing-runner-horse-sub-info">
                <span>{horseAge}</span>
                <span>{weight}</span>
              </div>
            </div>
          </div>
          <div className="hr-racing-runner-betting-odds">
            <span className="hr-racing-runner-betting-info">{odds}</span>
          </div>
        </div>

        <div className="hr-racing-runner-form-history-container">
          <div className="hr-racing-runner-form-key-info">
            <div className="hr-racing-runner-form-trainer-jockey-block">
              <Link className="hr-racing-runner-form-trainer" to={`/racing/profiles/trainer/${trainer.business_reference.id}`}>T:&nbsp;<span>{trainer.name}</span></Link>
              <Link className="hr-racing-runner-form-jockey" to={`/racing/profiles/jockey/${jockey.person_reference.id}`}>
                J:&nbsp;
                <span className="hr-racing-runner-form-jockey-name">{jockey.name}</span>
                <span className="hr-racing-runner-form-jockey-claim">{` ${jockeyClaim}`}</span>
              </Link>
              { rideDescPlusBetMovements &&
                <div className="hr-racing-runner-ride-desc-info">{rideDescPlusBetMovements}</div>
              }
            </div>
            <div className="hr-racing-runner-ride-desc-my-stable-btn">
              <SubscriptionContainer
                addSubscriptions={ [{ type: "HORSE", id: horseId, text: horseName }] }
                icon={ <MyStableButton /> }
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardResultRunner.js